// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"fcc84736","453":"9bf0fb47","779":"22725ee1"}[chunkId] + ".chunk.js";
};